import "./card.component.css";
import Button from "../button/button.component";

function Card({
  photo,
  heading,
  subheading,
  btnText = "Read More",
  isBtnDark,
  onClick,
}) {
  return (
    <div className="card-container d-flex flex-column align-items-center padding-h-15">
      <img className="photo w-100" src={photo} alt="case study" />
      <div className="font-bold font-1 padding-v-15 text-center">{heading}</div>
      <div className="font-semi-light font-2 padding-v-15 no-padding-top text-center">
        {subheading}
      </div>
      <Button text={btnText} onClick={onClick} isDark={isBtnDark} />
    </div>
  );
}

export default Card;
